import type { Note } from '@/store/notesStore';
import type { ApiNote } from '@/api/notes/types';
import { getCachedNoteBody } from '@/services/NoteBodyCache';

/** Maps a raw API note response to the client-side Note model. */
export function mapApiToNote(n: ApiNote): Note {
  const encrypted = Boolean(n.encrypted);
  const revision = n.seq ?? 0;
  const cachedBody = encrypted ? getCachedNoteBody(n.id, revision) : undefined;
  return {
    id: n.id,
    title: n.title ?? undefined,
    content: cachedBody ?? n.content,
    encrypted,
    body_locked: encrypted && cachedBody === undefined,
    has_history: n.has_history,
    has_key_wrapper: n.has_key_wrapper,
    content_type: n.content_type ?? 'TXT',
    content_status: n.content_status ?? 'final',
    content_id: n.content_id,
    seq: revision,
    color: n.color ?? undefined,
    pinned: Boolean(n.pinned),
    date: n.created_at ? n.created_at.slice(0, 10) : undefined,
    content_updated_at: n.content_updated_at ?? undefined,
    user_name: n.user_name ?? undefined,
    tags: n.tags ?? [],
  };
}
